import { alias, createModelSchema } from "serializr";
import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleTreasureGate extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.EXPEDITION_TREASURE_GATE);

        this._product = null;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    valid() {

        if (!this.product || this.product.length === 0) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.product || this.product.length === 0) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleTreasureGate());
        } else if (target instanceof SmartOfferBundleTreasureGate) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleTreasureGate, {
    _product: alias("product", Schema.primitive())
});